<template>
  <div class="col-md-6 p-2" @click="dialog=true">
    <custom-popup v-model="dialog" :cons="{title:'ویرایش اطلاعات'}" max-width="500">
      <v-card flat>
        <v-card-text>
          <v-text-field label="نام مشتری" outlined dense v-model="localValue.name"/>

          <v-text-field hide-details label="لینک" outlined dense v-model="localValue.link"/>

          <pic-selector-single v-model="localValue.image" class="mb-4"/>

          <v-textarea label="توضیحات" outlined dense v-model="localValue.description"/>
        </v-card-text>
      </v-card>
    </custom-popup>

    <v-card outlined>
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-title class="mb-1">
            <h5 class="font-weight-bold">
              {{ localValue.name }}
            </h5>
          </v-list-item-title>
          <v-list-item-subtitle class="clamp">{{ localValue.description }}</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-avatar size="80" class="my-auto">
          <v-icon v-if="!localValue.image" x-large>mdi-account</v-icon>

          <v-img v-else :src="localValue.image"/>
        </v-list-item-avatar>
      </v-list-item>
    </v-card>
  </div>
</template>

<script>
import PicSelectorSingle from "@/view/components/UploadCenter/picSelectorSingle";

export default {
  name: "CreateLogoCustomer",
  components: {PicSelectorSingle},
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    localValue() {
      let value;

      if (Object.keys(this.value).length > 0)
        value = this.value;
      else {
        value = {
          name: "نام مشتری",
          description: "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است",
          image: null,
          link:''
        };

        this.$emit('input', value);
      }

      return value;
    }
  },

}
</script>

<style scoped>
* {
  letter-spacing: 0 !important
}

.clamp {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>